module.exports = __webpack_public_path__ + "img/168724.db9fd9c4.png";